import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import { Observable } from "rxjs";

import {
    ActiveFilter,
    ProductListBreadcrumb,
    SortOption,
} from "./product-list-header.types";
import { ExportFormat } from "../../../../../shared/types/export-format.types";

@Component({
    selector: "vsf-product-list-header",
    templateUrl: "./product-list-header.component.html",
    styleUrls: ["./product-list-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListHeaderComponent {
    @Input() breadcrumbs$: Observable<ProductListBreadcrumb[]>;
    @Input() activeFilters$: Observable<ActiveFilter[]>;
    @Input() activeSortLabel = "Best price";
    @Input() sortDropdownOpen = false;
    @Input() sortOptions: SortOption[] = [];
    @Input() viewMode: "grid" | "table" = "table";
    @Input() failedProductGtins: string[] = [];
    @Input() moqViolations: Array<{ gtin: string; moq: number; quantity: number }> = [];
    @Input() downloadLabel = "Download Catalog";
    @Input() isConsolidatedFeed = false;
    @Input() pageTitle = "";
    @Input() offerCount: number | null = null;
    @Input() brandCount: number | null = null;
    @Input() sellerCount: number | null = null;
    @Input() showStats = true;
    @Input() showFreshPrices = true;

    @Output() toggleSidebarEvent = new EventEmitter<void>();
    @Output() removeFilterEvent = new EventEmitter<ActiveFilter>();
    @Output() clearAllFiltersEvent = new EventEmitter<void>();
    @Output() toggleSortDropdownEvent = new EventEmitter<void>();
    @Output() selectSortOptionEvent = new EventEmitter<SortOption>();
    @Output() toggleViewModeEvent = new EventEmitter<"grid" | "table">();
    @Output() downloadAllProductsEvent = new EventEmitter<ExportFormat>();
    @Output() shareCatalogLinkEvent = new EventEmitter<ExportFormat>();
    @Output() failedProductGtinsChange = new EventEmitter<string[]>();
    @Output() moqViolationsChange = new EventEmitter<
        Array<{ gtin: string; moq: number; quantity: number }>
    >();
}
